import { NetcashAddInvoicesResultDTO } from '../services/apiClient';

// Accounts for every invoice that was submitted, so the numbers always add up.
export const describeNetcashAddResult = (result?: NetcashAddInvoicesResultDTO): string => {
  const added = result?.addedCount ?? 0;
  const here = result?.alreadyInThisBatchCount ?? 0;
  const elsewhere = result?.alreadyInBatchCount ?? 0;
  const ineligible = result?.ineligibleCount ?? 0;

  const parts = [`${added} invoice(s) added`];
  if (here > 0) parts.push(`${here} already in this batch`);
  if (elsewhere > 0) parts.push(`${elsewhere} skipped - already in another Netcash batch`);
  if (ineligible > 0) parts.push(`${ineligible} skipped - not an unpaid sales order`);

  return parts.join(', ') + '.';
};
